import { useI18n, LanguageSwitcher } from "@/i18n";
import { TermsContent } from "./TermsContent";

export function TermsPage() {
  const { t } = useI18n();

  return (
    <div className="terms-page">
      {/* Language Switcher */}
      <div className="page-language-switcher">
        <LanguageSwitcher />
      </div>

      <div className="terms-container">
        <header className="terms-header">
          <a href="/" className="back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            {t.common.backToHome}
          </a>
          <h1>{t.terms.title}</h1>
        </header>

        <TermsContent />
      </div>
    </div>
  );
}
